import React, { useEffect, useMemo, useState } from "react";
import {
    Box,
    Typography,
    Button,
    Card,
    CardContent,
    Grid,
    Avatar,
    styled,
    Divider,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    MenuItem,
    IconButton,
    Container,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getCustomerById } from "../services/customers";
import { EmojiEvents, Loop, GroupWork } from "@mui/icons-material";
import { getUserById } from "../services/authService";
import userLogo from "../assets/user-logo.svg";
//add
import { updateUser } from "../services/authService";
import { updatePassword } from "../services/authService";
//add
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PersonIcon from "@mui/icons-material/Person";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";


const FormContainer = styled(Card)(() => ({
    background: "white",
    borderRadius: "20px",
    padding: "30px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
    margin: "0 auto",
    maxWidth: "100%",
    position: "relative",
    textAlign: "center",
}));

const InfoCard = styled(Card)(() => ({
    borderRadius: "18px",
    boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
    background: "linear-gradient(135deg, #ffffff, #f9fafb)",
    transition: "all 0.3s ease",
    textAlign: "center",
    padding: "24px 16px",
}));

const ProgressCard = styled(Card)(() => ({
    borderRadius: "20px",
    boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
    background: "linear-gradient(135deg, #e0f2fe, #f9fafb)",
    padding: "30px 20px",
    textAlign: "center",
    maxWidth: "600px",
    transition: "transform 0.3s ease",
}));

// Backend/patient-creation systems don't always agree on how a language is
// spelled ("Hindi", "hindi", "hi", "hin", etc). This maps any of those
// variants onto the 3-letter codes used below.
const LANG_CODE_ALIASES = {
    english: "eng",
    en: "eng",
    eng: "eng",
    kannada: "kan",
    kn: "kan",
    kan: "kan",
    hindi: "hin",
    hi: "hin",
    hin: "hin",
    telugu: "tel",
    te: "tel",
    tel: "tel",
    bengali: "ben",
    bn: "ben",
    ben: "ben",
};

const normalizeLangCode = (code) => {
    if (!code) return null;
    const key = String(code).trim().toLowerCase();
    return LANG_CODE_ALIASES[key] || key;
};

// UI copy for this page, keyed by language code.
const translations = {
    eng: {
        myProfile: "My Profile",
        age: "Age",
        gender: "Gender",
        email: "Email",
        phone: "Phone",
        preferredLanguage: "Preferred Language",
        assignedDoctor: "Assigned Doctor",
        diagnosis: "Diagnosis",
        medicalInfo: "Medical Information",
        primaryDiagnosis: "Primary Diagnosis",
        stage: "Stage",
        dateOfDiagnosis: "Date of Diagnosis",
        treatmentType: "Treatment Type",
        treatmentStartDate: "Treatment Start Date",
        noOfCyclesPlanned: "No of cycles planned",
        currentCycle: "Current Cycle",
        hospitalClinic: "Hospital / Clinic",
        sessionsCompleted: "Sessions Completed",
        na: "N/A",
    },
    kan: {
        myProfile: "ನನ್ನ ಪ್ರೊಫೈಲ್",
        age: "ವಯಸ್ಸು",
        gender: "ಲಿಂಗ",
        email: "ಇಮೇಲ್",
        phone: "ಫೋನ್",
        preferredLanguage: "ಆದ್ಯತೆಯ ಭಾಷೆ",
        assignedDoctor: "ನಿಯೋಜಿತ ವೈದ್ಯರು",
        diagnosis: "ರೋಗನಿರ್ಣಯ",
        medicalInfo: "ವೈದ್ಯಕೀಯ ಮಾಹಿತಿ",
        primaryDiagnosis: "ಪ್ರಾಥಮಿಕ ರೋಗನಿರ್ಣಯ",
        stage: "ಹಂತ",
        dateOfDiagnosis: "ರೋಗನಿರ್ಣಯದ ದಿನಾಂಕ",
        treatmentType: "ಚಿಕಿತ್ಸೆಯ ಪ್ರಕಾರ",
        treatmentStartDate: "ಚಿಕಿತ್ಸೆ ಪ್ರಾರಂಭ ದಿನಾಂಕ",
        noOfCyclesPlanned: "ಯೋಜಿತ ಚಕ್ರಗಳ ಸಂಖ್ಯೆ",
        currentCycle: "ಪ್ರಸ್ತುತ ಚಕ್ರ",
        hospitalClinic: "ಆಸ್ಪತ್ರೆ / ಕ್ಲಿನಿಕ್",
        sessionsCompleted: "ಪೂರ್ಣಗೊಂಡ ಅಧಿವೇಶನಗಳು",
        na: "ಲಭ್ಯವಿಲ್ಲ",
    },
    hin: {
        myProfile: "मेरी प्रोफ़ाइल",
        age: "आयु",
        gender: "लिंग",
        email: "ईमेल",
        phone: "फ़ोन",
        preferredLanguage: "पसंदीदा भाषा",
        assignedDoctor: "नियुक्त डॉक्टर",
        diagnosis: "निदान",
        medicalInfo: "चिकित्सा जानकारी",
        primaryDiagnosis: "प्राथमिक निदान",
        stage: "चरण",
        dateOfDiagnosis: "निदान की तिथि",
        treatmentType: "उपचार का प्रकार",
        treatmentStartDate: "उपचार प्रारंभ तिथि",
        noOfCyclesPlanned: "नियोजित चक्रों की संख्या",
        currentCycle: "वर्तमान चक्र",
        hospitalClinic: "अस्पताल / क्लिनिक",
        sessionsCompleted: "पूर्ण सत्र",
        na: "उपलब्ध नहीं",
    },
};

export default function MyProfile() {
    const navigate = useNavigate();
    const storedCustomer = JSON.parse(localStorage.getItem("customer") || "{}");
    const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
    //add
    const accountId = localStorage?.getItem("account_id");
    const message = localStorage.getItem('loginMessage');

    const role = localStorage.getItem("role");

    const { customer_id, account_id } = storedCustomer;
    const { id } = storedUser;

    console.log("id", id)

    const [customer, setCustomer] = useState(null);
    const [user, setUser] = useState(null);
    //add
    const [editOpen, setEditOpen] = useState(false);
    const [editData, setEditData] = useState({
        name: "",
        email: "",
        phone: "",
        gender: "",
    });
    console.log("customer", customer)

    useEffect(() => {
        if (customer_id && account_id) {
            getCustomerById(customer_id, account_id)
                .then((data) => setCustomer(data))
                .catch((err) => console.error("Failed to fetch customer:", err));
        }
    }, []);



    const loadUser = async () => {
        try {
            const data = await getUserById(id); // pass id
            setUser(data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (id) loadUser();
    }, [id]);

    const loadUser1 = async () => {
        try {
            const data = await getUserById(id);
            console.log("USER FROM API:", data);

            const safe = {
                name: data?.name || "",
                email: data?.email || "",
                phone: data?.phone || "",
                gender: data?.gender || "",
                created_at: data?.created_at || "",
            };

            setUser(safe);
            setEditData(safe);
        } catch (error) {
            console.error(error);
        }
    };
    useEffect(() => {
        if (id) loadUser1();
    }, [id]);


    // --- open dialog: always copy user into editData first ---
    const openEditDialog = () => {
        setEditData({
            name: user?.name || "",
            email: user?.email || "",
            phone: user?.phone || "",

        });
        setEditOpen(true);
    };
    // Reset password modal open state
    const [resetPasswordOpen, setResetPasswordOpen] = useState(false);

    // Password form data & errors
    const [passwordData, setPasswordData] = useState({
        current: "",
        new: "",
        confirm: "",
    });
    const [errors, setErrors] = useState({
        current: "",
        new: "",
        confirm: "",
    });

    const [showPassword, setShowPassword] = React.useState({
        current: false,
        new: false,
        confirm: false,
    });

    const handleClickShowPassword = (field) => {
        setShowPassword((prev) => ({
            ...prev,
            [field]: !prev[field],
        }));
    };

    const handleSaveProfile = async () => {
        try {

            const payload = {
                name: editData.name,
                phone: editData.phone,
                account_id: accountId,  //make sure this is set properly
                // gender: editData.gender, // if needed
            };



            const updatedUser = await updateUser(id, payload);



            // Update UI and localStorage
            setUser((prev) => ({
                ...prev,
                name: updatedUser.name,
                phone: updatedUser.phone,
            }));

            const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
            localStorage.setItem(
                "user",
                JSON.stringify({
                    ...storedUser,
                    name: updatedUser.name,
                    phone: updatedUser.phone,
                })
            );
            loadUser1();
            setEditOpen(false);
        } catch (error) {
            console.error("Error updating profile:", error);
            alert(error.message || "Update failed");
        }
    };

    const languageMap = {
        eng: "English",
        kan: "Kannada",
        hin: "Hindi",
        tel: "Telugu",
        ben: "Bengali",
    };

    // ----------------------- LANGUAGE -----------------------
    // Prefer the freshly-fetched customer record; fall back to whatever is in
    // localStorage until that fetch resolves.
    const rawPreferredLang =
        customer?.preferred_language || storedCustomer?.preferred_language || "eng";
    const normalizedPreferredLang = normalizeLangCode(rawPreferredLang);
    const preferredLang = translations[normalizedPreferredLang]
        ? normalizedPreferredLang
        : "eng";

    const [currentLang, setCurrentLang] = useState(preferredLang);

    // Re-sync the displayed language once the authoritative customer record
    // loads (preferredLang starts out based on localStorage/"eng" and may
    // change once the API response comes back).
    useEffect(() => {
        setCurrentLang(preferredLang);
    }, [preferredLang]);

    const handleToggle = () => {
        setCurrentLang((prev) => (prev === "eng" ? preferredLang : "eng"));
    };

    // const t = translations[currentLang] || translations.eng;
    const t = translations.eng;

    const sessionComplete = useMemo(
        () => localStorage.getItem("sessionComplete") === "true",
        []
    );

    const handlePasswordUpdate = async () => {
        let tempErrors = { current: "", new: "", confirm: "" };

        // 1. new must be different
        if (passwordData.current === passwordData.new) {
            tempErrors.new = "New password must be different from current password.";
        }

        // 2. new = confirm
        if (passwordData.new !== passwordData.confirm) {
            tempErrors.confirm = "New password and confirm password do not match.";
        }

        setErrors(tempErrors);

        // Stop if errors exist
        if (tempErrors.new || tempErrors.confirm) return;

        // 3. Call backend API
        try {
            const result = await updatePassword(id, {
                current: passwordData.current,
                new: passwordData.new,
            });

            alert("Password updated successfully!");
            setResetPasswordOpen(false);

            // Reset fields
            setPasswordData({ current: "", new: "", confirm: "" });
        } catch (err) {
            setErrors((prev) => ({
                ...prev,
                current: err.message, // show backend error under current password
            }));
        }
    };

    return (
        <>
            {role === "user" ? (
                //             {/* || role === "customer") &&
                //  (message === "Customer login successful" || message === "PIN validated successfully") ? ( */}
                <>

                    <Box
                        sx={{
                            width: "100vw",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",  // pushes Back button to right
                            padding: "15px 20px",
                        }}
                    >
                        <Typography variant="h6" sx={{ fontWeight: 700, color: "#0B2D6B" }}>
                            My Profile
                        </Typography>

                        <Button
                            variant="outlined"
                            onClick={() => navigate("/patients")}
                            sx={{
                                textTransform: "none",
                                borderRadius: "8px",
                                borderColor: "#0B2D6B",
                                color: "#0B2D6B",
                                px: 2,
                                mr: 3, // button stays right but not touching border
                            }}
                        >
                            Back
                        </Button>
                    </Box>

                    {/* Profile Card */}
                    <Box
                        sx={{
                            p: 4,
                            borderRadius: 4,
                            backgroundColor: "#fff",
                            maxWidth: 600,
                            mx: "auto",
                            boxShadow: "0px 4px 18px rgba(0,0,0,0.08)",
                            mt: 4,
                        }}
                    >
                        <Box
    sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        justifyContent: "space-between",
        alignItems: { xs: "flex-start", sm: "center" },
        gap: 2,
    }}
>
    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Avatar
            sx={{
                width: { xs: 56, sm: 70 },
                height: { xs: 56, sm: 70 },
                fontSize: { xs: "1.4rem", sm: "1.8rem" },
                bgcolor: "#0B2D6B",
            }}
        >
            {user?.name?.charAt(0)?.toUpperCase() || "U"}
        </Avatar>

        <Box>
            <Typography variant="h6" sx={{ fontWeight: 600, fontSize: { xs: "1rem", sm: "1.25rem" } }}>
                {user?.name}
            </Typography>
            <Typography variant="body2" sx={{ color: "gray", fontSize: { xs: "0.75rem", sm: "0.875rem" } }}>
                Member since{" "}
                {user?.created_at
                    ? new Date(user.created_at).toLocaleDateString()
                    : "Loading..."}
            </Typography>
        </Box>
    </Box>

    <Box sx={{ display: "flex", gap: 1, width: { xs: "100%", sm: "auto" } }}>
        <Button
            variant="outlined"
            sx={{
                textTransform: "none",
                borderRadius: 2,
                borderColor: "#0B2D6B",
                color: "#0B2D6B",
                flex: { xs: 1, sm: "none" },
                "&:hover": { backgroundColor: "#0B2D6B", color: "#fff" },
            }}
            onClick={() => setResetPasswordOpen(true)}
        >
            Reset Password
        </Button>

        <Button
            variant="contained"
            sx={{
                textTransform: "none",
                borderRadius: 2,
                backgroundColor: "#0B2D6B",
                flex: { xs: 1, sm: "none" },
                "&:hover": { backgroundColor: "#08275a" },
            }}
            onClick={() => setEditOpen(true)}
        >
            Edit
        </Button>
    </Box>
</Box>

                        <Divider sx={{ my: 3 }} />

                        {/* Contact Info */}
                        <Box
                            sx={{
                                display: "flex",
                                gap: 3,
                                mt: 3,
                            }}
                        >
                            {/* Left Side */}
                            <Box
                                sx={{
                                    flex: 1,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    gap: 3,
                                }}
                            >
                                <Box>
                                    <Typography variant="subtitle1" fontWeight={600}>
                                        Email
                                    </Typography>
                                    <Typography>{user?.email}</Typography>
                                </Box>

                                <Box>
                                    <Typography variant="subtitle1" fontWeight={600}>
                                        Mobile Number
                                    </Typography>
                                    <Typography>{user?.phone || "Not provided"}</Typography>
                                </Box>
                            </Box>

                            {/* Right Side */}
                            <Box
                                sx={{
                                    flex: 1,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    gap: 3,
                                }}
                            >
                                <Box>
                                    <Typography variant="subtitle1" fontWeight={600}>
                                        Gender
                                    </Typography>
                                    <Typography>{user?.gender || "Not specified"}</Typography>
                                </Box>

                                <Box>
                                    <Typography variant="subtitle1" fontWeight={600}>
                                        Status
                                    </Typography>
                                    <Typography>{user?.status || "Active"}</Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Box>

                    {/* Edit Profile Dialog */}
                    <Dialog
                        open={editOpen}
                        onClose={() => setEditOpen(false)}
                        fullWidth
                        maxWidth="xs"
                        PaperProps={{
                            sx: {
                                borderRadius: 4,
                                p: 2,
                                background: "#ffffff",
                                boxShadow: "0px 8px 30px rgba(0,0,0,0.15)",
                                width: "360px",
                            },
                        }}
                    >
                        <DialogTitle
                            sx={{
                                textAlign: "center",
                                fontWeight: 700,
                                fontSize: "1.1rem",
                                color: "#0B2D6B",
                                pb: 1,
                            }}
                        >
                            Edit Profile
                        </DialogTitle>

                        <Box sx={{ my: 2 }}>
                            <TextField
                                fullWidth
                                label="Full Name *"
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                                value={editData.name}
                                onChange={(e) => setEditData({ ...editData, name: e.target.value })}
                            />



                        </Box>

                        <Box sx={{ mb: 2 }}>
                            <TextField
                                fullWidth
                                label="Email Address *"
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                                value={user?.email}
                                disabled
                                sx={{
                                    "& .MuiOutlinedInput-root": { backgroundColor: "#EFEFEF" },
                                    "& .MuiInputBase-input.Mui-disabled": { WebkitTextFillColor: "#6B7280" },
                                }}
                            />

                        </Box>

                        <Box sx={{ mb: 2 }}>
                            <TextField
                                fullWidth
                                label="Phone Number *"
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                                value={editData.phone}
                                onChange={(e) => setEditData({ ...editData, phone: e.target.value })}
                            />
                        </Box>



                        <DialogActions
                            sx={{
                                px: 2,
                                pb: 2,
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: 1.5,
                            }}
                        >
                            <Button
                                variant="text"
                                sx={{
                                    textTransform: "none",
                                    color: "#6b7280",
                                    "&:hover": { backgroundColor: "#f5f5f5" },
                                }}
                                onClick={() => setEditOpen(false)}
                            >
                                Cancel
                            </Button>

                            <Button
                                variant="contained"
                                sx={{
                                    textTransform: "none",
                                    borderRadius: 2,
                                    backgroundColor: "#0B2D6B",
                                    px: 3,
                                    "&:hover": { backgroundColor: "#08295F" },
                                }}
                                onClick={handleSaveProfile}
                            >
                                Save
                            </Button>
                        </DialogActions>
                    </Dialog>

                    {/* Reset Password Dialog */}
                    <Dialog
                        open={resetPasswordOpen}
                        onClose={() => setResetPasswordOpen(false)}
                        fullWidth
                        maxWidth="xs"
                        PaperProps={{
                            sx: {
                                borderRadius: 4,
                                p: 2,
                                background: "#ffffff",
                                boxShadow: "0px 8px 30px rgba(0,0,0,0.15)",
                                width: "360px",
                            },
                        }}
                    >
                        <DialogTitle
                            sx={{
                                textAlign: "center",
                                fontWeight: 700,
                                fontSize: "1.1rem",
                                color: "#0B2D6B",
                                pb: 0,
                            }}
                        >
                            Reset Password
                        </DialogTitle>

                        <Box sx={{ my: 2 }}>
                            <TextField
                                fullWidth
                                label="Current Password"
                                type={showPassword.current ? "text" : "password"}  // toggle type here
                                InputLabelProps={{ shrink: true }}
                                variant="outlined"
                                value={passwordData.current}
                                onChange={(e) =>
                                    setPasswordData({ ...passwordData, current: e.target.value })
                                }
                                error={Boolean(errors.current)}
                                helperText={errors.current}
                                required
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle current password visibility"
                                                onClick={() => handleClickShowPassword("current")}
                                                edge="end"
                                            >
                                                {showPassword.current ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />

                        </Box>

                        <TextField
                            fullWidth
                            label="New Password "
                            type={showPassword.new ? "text" : "password"}
                            InputLabelProps={{ shrink: true }}
                            variant="outlined"
                            value={passwordData.new}
                            onChange={(e) =>
                                setPasswordData({ ...passwordData, new: e.target.value })
                            }
                            error={Boolean(errors.new)}
                            helperText={errors.new}
                            required
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle new password visibility"
                                            onClick={() => handleClickShowPassword("new")}
                                            edge="end"
                                        >
                                            {showPassword.new ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />

                        <Box sx={{ my: 2 }}>
                            <TextField
                                fullWidth
                                label="Confirm Password "
                                type={showPassword.confirm ? "text" : "password"}
                                InputLabelProps={{ shrink: true }}
                                variant="outlined"
                                value={passwordData.confirm}
                                onChange={(e) => {
                                    const confirmValue = e.target.value;
                                    setPasswordData({ ...passwordData, confirm: confirmValue });

                                    // Live validation for confirm password matching new password
                                    if (confirmValue !== passwordData.new) {
                                        setErrors((prev) => ({ ...prev, confirm: "Passwords do not match" }));
                                    } else {
                                        setErrors((prev) => ({ ...prev, confirm: "" }));
                                    }
                                }}
                                error={Boolean(errors.confirm)}
                                helperText={errors.confirm}
                                required
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle confirm password visibility"
                                                onClick={() => handleClickShowPassword("confirm")}
                                                edge="end"
                                            >
                                                {showPassword.confirm ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>



                        <DialogActions
                            sx={{
                                px: 2,
                                pb: 2,
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: 1.5,
                            }}
                        >
                            <Button
                                variant="text"
                                sx={{
                                    textTransform: "none",
                                    color: "#6b7280",
                                    "&:hover": { backgroundColor: "#f5f5f5" },
                                }}
                                onClick={() => setResetPasswordOpen(false)}
                            >
                                Cancel
                            </Button>

                            <Button
                                variant="contained"
                                sx={{
                                    textTransform: "none",
                                    borderRadius: 2,
                                    backgroundColor: "#0B2D6B",
                                    px: 3,
                                    "&:hover": { backgroundColor: "#08295F" },
                                }}
                                onClick={handlePasswordUpdate}
                            >
                                Update
                            </Button>
                        </DialogActions>
                    </Dialog>
                </>
            ) : (
                <FormContainer>
                    {/* ✅ Header Section */}
                    {/* <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                        }}
                    >
                        <Typography variant="h6" fontWeight={400} sx={{ color: "#1f2937" }}>
                            {t.myProfile}
                        </Typography>

                        {preferredLang !== "eng" && (
                            <Button
                                variant="contained"
                                onClick={handleToggle}
                                sx={{
                                    bgcolor: "#1976d2",
                                    "&:hover": { bgcolor: "#1565c0" },
                                    borderRadius: 2,
                                    px: { xs: 1.8, sm: 2.5 },
                                    py: { xs: 0.9, sm: 1 },
                                    textTransform: "none",
                                    fontWeight: 600,
                                    fontSize: { xs: "0.8rem", sm: "0.875rem" },
                                    whiteSpace: "nowrap",
                                    mt: -4, 
                                }}
                            >
                                {currentLang === "eng" ? languageMap[preferredLang] : "English"}
                            </Button>
                        )}
                    </Box> */}

                    {/* ✅ Centered Content Section */}
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 4,
                        }}
                    >
                        <Box sx={{
                            background: '#f8f9ff',
                            p: { xs: 2, sm: 3 },
                            borderRadius: { xs: '8px', sm: '10px' },
                        }}>
                            <Box display="flex" justifyContent="space-between">
                                <Box display="flex" justifyContent="space-between" alignItems="center" gap={2}>
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            color: '#1a1238',
                                            fontSize: { xs: '1rem', sm: '1.25rem' },
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1
                                        }}
                                    >
                                        <img
                                            src={
                                                customer?.gender?.toLowerCase() === "male"
                                                    ? "/man.png"
                                                    : customer?.gender?.toLowerCase() === "female"
                                                        ? "/woman.png"
                                                        : userLogo
                                            }
                                            alt="gender-icon"
                                            style={{ width: 24, height: 24 }}
                                        />

                                        {customer?.firstname} {customer?.lastname}
                                    </Typography>
                                    <Typography sx={{
                                        color: '#666',
                                        fontSize: { xs: '1rem', sm: '1.25rem' },
                                        lineHeight: { xs: 1.6, sm: 1.5 }
                                    }}>
                                        {t.age}: {customer?.age || t.na} | {t.gender}: {customer?.gender || t.na}
                                    </Typography>
                                </Box>

                            </Box>

                            <Typography sx={{
                                color: '#666',
                                fontSize: { xs: '0.85rem', sm: '1rem' },
                                lineHeight: { xs: 1.6, sm: 1.5 },
                                mt: 1,
                            }}>
                                {t.email}: {customer?.email || t.na} | {t.phone}: {customer?.phone || t.na} |
                                {" "}{t.preferredLanguage}: {languageMap[preferredLang] || t.na}
                            </Typography>

                            <Typography sx={{
                                color: '#666',
                                fontSize: { xs: '0.85rem', sm: '1rem' },
                                lineHeight: { xs: 1.6, sm: 1.5 },
                                mt: 1,
                            }}>
                                {t.assignedDoctor}: {customer?.assigned_doctor_name || t.na} | {t.diagnosis}: {customer?.diagnosis || t.na}
                            </Typography>

                            <Box
                                sx={{
                                    p: 2,
                                    border: '1px solid #e5e7eb',
                                    borderRadius: '10px',
                                    backgroundColor: '#f9fafb',
                                    m: 2
                                }}
                            >
                                <Typography sx={{
                                    color: '#666',
                                    mt: 1,
                                    fontSize: { xs: '0.85rem', sm: '1rem' },
                                    lineHeight: { xs: 1.6, sm: 1.5 }
                                }}>
                                    {t.medicalInfo} — {t.primaryDiagnosis}: {customer?.primary_diagnosis ?? t.na} |
                                    {" "}{t.stage}: {customer?.stage ?? t.na} |
                                    {" "}{t.dateOfDiagnosis}: {new Date(customer?.date_of_diagnosis).toLocaleString() ?? t.na}  |
                                    {" "}{t.treatmentType}: {customer?.treatment_type ?? t.na} |
                                    {" "}{t.treatmentStartDate}: {new Date(customer?.treatment_start_date).toLocaleString() ?? t.na} |

                                    {" "}{t.noOfCyclesPlanned}: {customer?.no_of_cycles_planned ?? t.na} |
                                    {" "}{t.currentCycle}: {customer?.current_cycle ?? t.na} |
                                    {" "}{t.hospitalClinic}: {customer?.hospital ?? t.na} |
                                </Typography>
                            </Box>

                        </Box>
                        {/* 🟦 Icon + Text in One Box */}
                        {/* <ProgressCard
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                textAlign: "center",
                                py: 3.5,
                                px: 3,
                                background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)", // much lighter tone
                                border: "1px solid #e2e8f0",
                                boxShadow: "0 4px 14px rgba(0,0,0,0.05)",
                            }}
                        >
                            <Avatar
                                src="/photos/progress.png"
                                alt="Progress Icon"
                                sx={{
                                    width: 65,
                                    height: 65,
                                    bgcolor: "#f0f9ff",
                                    color: "#2563eb",
                                    fontSize: 28,
                                    mb: 2,
                                    boxShadow: "0 3px 8px rgba(37,99,235,0.15)",
                                }}
                            >
                                📈
                            </Avatar>

                            <Typography
                                variant="h6"
                                fontWeight={700}
                                sx={{
                                    color: "#1e3a8a",
                                    mb: 1,
                                    letterSpacing: "0.3px",
                                }}
                            >
                                Progress Tracking
                            </Typography>

                            <Typography
                                variant="body2"
                                sx={{
                                    color: "#475569",
                                    lineHeight: 1.8,
                                    maxWidth: "460px",
                                    fontSize: "0.93rem",
                                }}
                            >
                                Your progress and therapy outcomes will be displayed here.
                                <br />
                                Complete more sessions to see your journey.
                            </Typography>
                        </ProgressCard> */}

                        {/* ✅ Info Cards */}
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                width: "100%",
                                mt: 2,
                            }}
                        >
                            <Box
                                sx={{
                                    display: "grid",
                                    gridTemplateColumns: {
                                        xs: "1fr",         // mobile
                                        sm: "repeat(2, 1fr)", // tablet
                                        md: "repeat(2, 1fr)", // desktop
                                    },
                                    gap: 3,
                                    width: "100%",
                                    maxWidth: "900px",
                                }}
                            >
                                {/* ✅ Sessions Completed */}
                                <InfoCard
                                    sx={{
                                        py: 2.5,
                                        px: 2,
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        minHeight: "140px",
                                    }}
                                >
                                    <EmojiEvents sx={{ fontSize: 34, color: "#3b82f6", mb: 1 }} />
                                    <Typography variant="subtitle2" sx={{ color: "#6b7280", mb: 0.3 }}>
                                        {t.sessionsCompleted}
                                    </Typography>
                                    <Typography
                                        variant="h5"
                                        fontWeight={700}
                                        sx={{ color: "#111827" }}
                                    >
                                        {customer?.treatment_cycle - 1}
                                    </Typography>
                                </InfoCard>

                                {/* ✅ Current Cycle */}
                                <InfoCard
                                    sx={{
                                        py: 2.5,
                                        px: 2,
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        minHeight: "140px",
                                    }}
                                >
                                    <Loop sx={{ fontSize: 34, color: "#10b981", mb: 1 }} />
                                    <Typography variant="subtitle2" sx={{ color: "#6b7280", mb: 0.3 }}>
                                        {t.currentCycle}
                                    </Typography>
                                    <Typography
                                        variant="h5"
                                        fontWeight={700}
                                        sx={{ color: "#111827" }}
                                    >
                                        {customer?.treatment_cycle}
                                    </Typography>
                                </InfoCard>

                                {/* ✅ Treatment Arm */}
                                {/* <InfoCard
                                    sx={{
                                        py: 2.5,
                                        px: 2,
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        minHeight: "140px",
                                    }}
                                >
                                    <GroupWork sx={{ fontSize: 34, color: "#f59e0b", mb: 1 }} />
                                    <Typography variant="subtitle2" sx={{ color: "#6b7280", mb: 0.3 }}>
                                        Treatment Arm
                                    </Typography>
                                    <Typography
                                        variant="h5"
                                        fontWeight={700}
                                        sx={{ color: "#111827" }}
                                    >
                                        {customer?.assignment_role === "test_arm"
                                            ? "Test Arm"
                                            : customer?.assignment_role === "control_arm"
                                                ? "Control Arm"
                                                : customer?.assignment_role || "Test Arm"}
                                    </Typography>
                                </InfoCard> */}
                            </Box>
                        </Box>


                    </Box>

                </FormContainer>
            )}
        </>
    );
}
